import type { JSX } from 'react';
import { styled } from '@mui/material';
import { corePalette } from '@/themes/colours';
import { POPUP_BIOMARKER_COLUMNS } from '@/constants/PatientDashboard/patientTimeline';
import type { ITimelinePopupBiomarkerRow } from '@/types/PatientDashboard/PatientTimeline.types';
import AssayMarker from './AssayMarker';
import { formatChartValue } from './ChartLane.util';
import { MarkerDot } from './MarkerDotCluster.styles';
import { PopupRow, PopupRowName, PopupValueCell } from './TimelinePopup.styles';

const [vafColumn, refColumn, altColumn, depthColumn] = POPUP_BIOMARKER_COLUMNS;

const VafValue = styled(PopupValueCell)({
  fontWeight: 700,
  color: corePalette.grey200,
});

const CountValue = styled(PopupValueCell)({
  fontWeight: 500,
  color: corePalette.grey200,
});

interface IProps {
  row: ITimelinePopupBiomarkerRow;
}

export default function TimelinePopupBiomarkerRow({ row }: IProps): JSX.Element {
  return (
    <PopupRow>
      <MarkerDot style={{ background: row.lineColour }} />
      <PopupRowName truncate>{row.label}</PopupRowName>
      <AssayMarker assay={row.assay} colour={row.analyteColour} isDetected={row.isDetected} />
      <VafValue style={{ width: vafColumn.width }}>{formatChartValue(row.vaf)}</VafValue>
      <CountValue style={{ width: refColumn.width }}>{row.refad}</CountValue>
      <CountValue style={{ width: altColumn.width }}>{row.altad}</CountValue>
      <CountValue style={{ width: depthColumn.width }}>{row.depth}</CountValue>
    </PopupRow>
  );
}
